const translations = {
  // === NAVBAR & MENU ===
  'nav.beranda': 'Beranda',
  'nav.tentangKami': 'Tentang Kami',
  'nav.portofolio': 'Portofolio',
  'nav.news': 'Berita',
  'nav.karir': 'Karir',
  'nav.kontak': 'Kontak',
  'nav.hubungiKami': 'Hubungi Kami',
  'nav.beranda2': 'Beranda',

  // === HERO SECTION ===
  'hero.label': 'PT Waringin Mega Mandiri — Berdiri Sejak 2022',
  'hero.title1': 'Kontraktor Gedung',
  'hero.title2': 'Terpercaya',
  'hero.title3': 'Skala Nasional',
  'hero.subtitle': 'PT Waringin Mega Mandiri adalah anak perusahaan yang tergabung dalam Waringin Group dan telah membangun ruko, pabrik, gudang, hotel, apartemen, restoran, sekolah, kantor, bangunan bertingkat, rumah tinggal hingga kawasan industri.',
  'hero.lihatPortofolio': 'Lihat Portofolio',
  'hero.hubungiKami': 'Hubungi Kami',
  'hero.scroll': 'Gulir',
  'hero.stat.tahunPengalaman': 'Tahun Pengalaman',
  'hero.stat.proyekSelesai': 'Proyek Selesai',
  'hero.stat.kepuasanKlien': 'Kepuasan Klien',
  'hero.stat.klienKorporat': 'Klien Korporat',
  'hero.slogan': 'BUILD TO PERFECTION',

  // === SERVICES (LAYANAN) - FIXED INDONESIA ===
  'services.label': 'Apa Yang Kami Lakukan',
  'services.titleHighlight': 'Layanan',
  'services.titleSuffix': 'Kami',
  'services.subtitle': 'Kami menyediakan solusi konstruksi komprehensif dengan teknologi terdepan untuk memenuhi setiap kebutuhan proyek Anda.',
  'services.lingkupPekerjaan': 'Lingkup Pekerjaan',
  'services.lingkupSubtitle': 'Bidang konstruksi yang kami tangani secara profesional',
  'services.keunggulan': 'Keunggulan Kami',
  'services.mengapaWMM': 'Mengapa Memilih',
  'services.dukunganDesc': 'Kami hadir dengan dukungan penuh dari PT. Waringin Megah untuk memastikan setiap proyek berjalan optimal.',
  
  'service.gc.title': 'Kontraktor Umum',
  'service.gc.tagline': 'Solusi Konstruksi Profesional & Terpercaya',
  'service.gc.description': 'PT. Waringin Mega Mandiri hadir sebagai Kontraktor Umum profesional yang berpengalaman dalam pelaksanaan proyek konstruksi skala menengah hingga besar.',
  'service.gc.scope1.title': 'Gedung Komersial & Perkantoran',
  'service.gc.scope1.desc': 'Pembangunan gedung komersial, perkantoran, dan pusat perbelanjaan dengan standar konstruksi internasional.',
  'service.gc.scope2.title': 'Hunian & Residensial',
  'service.gc.scope2.desc': 'Konstruksi hunian premium, apartemen, dan perumahan dengan kualitas material terbaik dan pengerjaan presisi.',
  'service.gc.scope3.title': 'Fasilitas Publik & Institusi',
  'service.gc.scope3.desc': 'Pembangunan fasilitas publik, rumah sakit, sekolah, dan gedung pemerintahan.',
  'service.gc.scope4.title': 'Proyek Khusus & Serbaguna',
  'service.gc.scope4.desc': 'Penanganan proyek dengan kompleksitas tinggi, termasuk kawasan serbaguna (mixed-use).',
  'service.gc.why1': 'Tim Berpengalaman dari PT. Waringin Megah',
  'service.gc.why2': 'Manajemen Proyek Terstruktur & Transparan',
  'service.gc.why3': 'Komitmen Kualitas & Ketepatan Waktu',
  'service.gc.why4': 'Dukungan Penuh Tenaga, Peralatan & Keuangan',
  'service.gc.why5': 'Rekam Jejak Proyek yang Terbukti',
  'service.gc.why6': 'Komunikasi Aktif dengan Klien',
  'service.gc.stat1.val': '50+',
  'service.gc.stat1.label': 'Proyek Selesai',
  'service.gc.stat2.val': '100%',
  'service.gc.stat2.label': 'Kepuasan Klien',
  'service.gc.stat3.val': '2022',
  'service.gc.stat3.label': 'Tahun Berdiri',
  'service.gc.cta': 'Konsultasi Proyek',
  'service.6.title': 'Layanan & Pemeliharaan',

  // === TENTANG KAMI (ABOUT PAGE) ===
  'about.title': 'Tentang Kami',
  'about.subtitle': 'Mengenal lebih dekat PT Waringin Mega Mandiri — perusahaan konstruksi yang membangun Indonesia dengan teknologi dan integritas.',
  'about.breadcrumb': 'Tentang Kami',
  'about.beranda': 'Beranda',
  'about.fondasi': 'Fondasi Kami',
  'about.nilaiPerusahaan': 'Nilai Perusahaan',
  'about.perjalanan': 'Perjalanan Kami',
  'about.historyMilestone': 'History & Milestone',

  // === VISI & MISI (LENGKAP) ===
  'vm.label': 'Arah & Tujuan',
  'vm.title': 'Visi &',
  'vm.highlight': 'Misi',
  'vm.visi': 'Visi',
  'vm.misi': 'Misi',
  'vm.visiQuote': 'Menjadi perusahaan jasa konstruksi terpercaya yang menghadirkan produk berkualitas tinggi, terus berkembang secara menyeluruh, dan memberikan pelayanan terbaik demi kepuasan pelanggan.',
  'vm.misi1': 'Mewujudkan produk jasa konstruksi yang berkualitas tinggi dengan harga yang bersaing.',
  'vm.misi2': 'Melakukan pengembangan yang berkesinambungan secara menyeluruh di dalam semua aspek yang mendukung perusahaan.',
  'vm.misi3': 'Memberikan pelayanan yang terbaik kepada pelanggan.',

  // === PROFIL PERUSAHAAN ===
  'profile.label': 'Profil Perusahaan',
  'profile.title': 'PT Waringin',
  'profile.highlight': 'Mega Mandiri',
  'profile.founded': 'Didirikan',
  'profile.p1': 'PT. Waringin Mega Mandiri adalah perusahaan Jasa Konstruksi/Kontraktor Umum yang merupakan anak perusahaan dari PT. Waringin Megah yang berlokasi di Jakarta.',
  'profile.p2': 'PT. Waringin Mega Mandiri didirikan pada tahun 2022 dengan tujuan untuk mengerjakan proyek-proyek yang selama ini dikelola oleh Tim Manajemen PT. Waringin Megah divisi Jakarta.',
  'profile.p3': 'Tim Manajemen PT. Waringin Mega Mandiri selalu bertekad untuk melayani dan memuaskan semua pelanggan dengan memberikan hasil pekerjaan dengan kualitas yang terbaik.',
  'profile.kota': 'Beroperasi di Jakarta',
  'profile.tenaga': 'Tim Profesional Berpengalaman',
  'profile.proyek': 'Proyek Berkualitas Tinggi',
  'profile.standar': 'Didukung PT. Waringin Megah',

  // === NILAI PERUSAHAAN (VALUES) ===
  'values.label': 'Fondasi Kami',
  'values.title': 'Nilai',
  'values.highlight': 'Perusahaan',
  'value.1.title': 'Integritas',
  'value.1.desc': 'Kami menjunjung tinggi kejujuran dan transparansi dalam setiap aspek bisnis dan pelaksanaan proyek.',
  'value.2.title': 'Kualitas',
  'value.2.desc': 'Standar kualitas premium ISO 9001 diterapkan di setiap proses konstruksi.',
  'value.3.title': 'Inovasi',
  'value.3.desc': 'Terus berinovasi dengan teknologi terkini BIM, drone survey, dan AI dalam manajemen proyek konstruksi.',
  'value.4.title': 'Kolaborasi',
  'value.4.desc': 'Membangun kemitraan strategis yang saling menguntungkan dengan klien, konsultan, dan subkontraktor.',

  // === PORTOFOLIO ===
  'portfolio.title': 'Portofolio Proyek',
  'portfolio.subtitle': 'Rekam jejak kami dalam membangun berbagai proyek konstruksi bergengsi di seluruh Indonesia dengan standar kualitas terbaik.',
  'portfolio.breadcrumb': 'Portofolio',
  'portfolio.semua': 'Semua',
  'portfolio.gedung': 'Gedung',
  'portfolio.infrastruktur': 'Infrastruktur',
  'portfolio.renovasi': 'Renovasi',
  'portfolio.industrial': 'Industri',
  'portfolio.statusSelesai': 'Selesai',
  'portfolio.statusOngoing': 'Sedang Berjalan',
  'portfolio.menampilkan': 'Menampilkan',
  'portfolio.proyek': 'proyek',
  'portfolio.dalamKategori': 'dalam kategori',
  'portfolio.konsultasiCta': 'Tertarik bekerja sama dengan kami? Konsultasikan kebutuhan proyek konstruksi Anda sekarang.',
  'portfolio.konsultasiBtn': 'Konsultasi Proyek Anda',
  'portfolio.tidakAda': 'Tidak ada proyek dalam kategori ini.',

  // === KARIR (LENGKAP DENGAN DEPARTEMEN) ===
  'karir.badge': 'Bergabung Bersama Kami',
  'karir.title1': 'Bangun Karir di',
  'karir.title2': 'PT Waringin Mega Mandiri',
  'karir.subtitle': 'Bergabunglah dengan tim profesional kami dan jadilah bagian dari proyek-proyek konstruksi terbaik di Indonesia. Kami menghargai talenta, mendorong inovasi, dan berkomitmen pada pertumbuhan karir Anda.',
  'karir.mengapa': 'Mengapa Bergabung dengan WMM?',
  'karir.komunitas': 'Kami bukan sekadar tempat kerja — kami adalah komunitas profesional yang tumbuh bersama.',
  'karir.lowongan': 'Lowongan Tersedia',
  'karir.posisiTerbuka': 'posisi terbuka — temukan yang sesuai dengan keahlian Anda',
  'karir.semua': 'Semua',
  'karir.tidakAda': 'Belum ada lowongan saat ini.',
  'karir.tidakCocok': 'Tidak Menemukan Posisi yang Cocok?',
  'karir.kirimSpontan': 'Kirimkan CV Anda secara spontan ke email kami. Kami selalu mencari talenta terbaik.',
  'karir.kirimBtn': 'Kirim Lamaran Spontan',
  'karir.deskripsiPekerjaan': 'Deskripsi Pekerjaan',
  'karir.keuntungan': 'Keuntungan & Benefit',
  'karir.kualifikasi': 'Kualifikasi & Persyaratan',
  'karir.lamarSekarang': 'Lamar Sekarang',
  'karir.tanyaWA': 'Tanya via WhatsApp',
  'karir.deadline': 'Batas Waktu',
  'karir.dept.manajemen': 'Manajemen Proyek',
  'karir.dept.teknologi': 'Teknologi & Inovasi',
  'karir.dept.engineering': 'Engineering',
  'karir.dept.estimasi': 'Estimasi & Biaya',
  'karir.dept.hse': 'Kesehatan, Keselamatan & Lingkungan',
  'karir.dept.desain': 'Desain & Drafting',

  // === NEWS / BERITA ===
  'news.badge': 'Berita & Wawasan',
  'news.title1': 'Berita &',
  'news.title2': 'Update',
  'news.subtitle': 'Informasi terkini tentang proyek, teknologi konstruksi, dan perkembangan terbaru PT Waringin Mega Mandiri.',
  'news.artikelPilihan': 'Artikel Pilihan',
  'news.semua': 'Semua',
  'news.artikel': 'artikel',
  'news.tidakAda': 'Tidak ada artikel di kategori ini.',
  'news.newsletterTitle': 'Berlangganan Newsletter',
  'news.newsletterSubtitle': 'Dapatkan berita dan update proyek terbaru WMM langsung di inbox Anda.',
  'news.placeholder': 'email@contoh.com',
  'news.subscribe': 'Langganan',
  'news.subscribed': 'Berhasil berlangganan!',
  'news.bacaSelengkapnya': 'Baca selengkapnya',

  // === TIM MANAJEMEN ===
  'team.label': 'Para Pemimpin Kami',
  'team.title': 'Tim',
  'team.highlight': 'Manajemen',
  'team.subtitle': 'Dipimpin oleh para profesional berpengalaman dengan rekam jejak proyek konstruksi skala nasional dan internasional.',
  'team.pendiri': 'Pendiri Perusahaan',
  'team.direksi': 'Dewan Direksi',
  'team.orang': 'orang',
  'team.pos.pemegang': 'Pemegang Saham',
  'team.pos.komisaris': 'Komisaris Utama',
  'team.pos.direktur': 'Direktur Utama',
  'team.desc.1': 'Pengembang berdomisili di Surabaya. Bersama Ir. Yohanes Sucipto mendirikan PT. Waringin Megah pada tahun 1987.',
  'team.desc.2': 'Alumnus Fakultas Teknik Sipil Universitas Kristen Petra Surabaya tahun 1985. Bersama Eddy Susanto mendirikan PT. Waringin Megah.',
  'team.desc.3': 'Lulusan Teknik Sipil ITS Surabaya tahun 1989. Bergabung dengan PT. Waringin Megah sebagai Manajer Proyek, kini menjabat Komisaris Utama PT. Waringin Mega Mandiri.',
  'team.desc.4': 'Lulusan Teknik Sipil Universitas Kristen Maranatha Bandung tahun 1994. Bergabung dengan PT. Waringin Megah sebagai Manajer Proyek, kini menjabat Direktur Utama PT. Waringin Mega Mandiri.',

  // === KONTAK (PAGE & FORM) ===
  'kontak.heroBadge': 'Hubungi Kami',
  'kontak.heroTitle1': 'Mari',
  'kontak.heroTitle2': 'Berdiskusi',
  'kontak.heroSubtitle': 'Kami siap membantu mewujudkan proyek impian Anda. Konsultasi gratis, respon cepat, solusi terbaik.',
  'kontak.infoTitle': 'Informasi Kontak',
  'kontak.infoSubtitle': 'Hubungi kami melalui berbagai saluran komunikasi yang tersedia.',
  'kontak.address': 'Alamat Kantor',
  'kontak.addressVal': 'Jl. Bendungan Hilir Raya G1 No.5 Jakarta Pusat 10210',
  'kontak.addressSub': 'Lihat di Google Maps',
  'kontak.phone': 'Telepon',
  'kontak.phoneVal': '+62 21 5738001',
  'kontak.phoneSub': 'Senin – Sabtu, 08.00–17.00 WIB',
  'kontak.email': 'Email',
  'kontak.emailVal': 'info@waringinmegamandiri.com',
  'kontak.emailSub': 'Respon dalam 1×24 jam kerja',
  'kontak.whatsapp': 'WhatsApp',
  'kontak.whatsappVal': '+62 812-3456-7890',
  'kontak.hours': 'Jam Operasional',
  'kontak.weekdays': 'Senin – Jumat',
  'kontak.weekdaysHours': '08.00 – 17.00 WIB',
  'kontak.saturday': 'Sabtu',
  'kontak.saturdayHours': '08.00 – 13.00 WIB',
  'kontak.sunday': 'Minggu',
  'kontak.sundayHours': 'Tutup',
  'kontak.formTitle': 'Kirim Pesan',
  'kontak.formSubtitle': 'Isi formulir di bawah ini dan tim kami akan segera menghubungi Anda.',
  'kontak.name': 'Nama Lengkap',
  'kontak.namePlaceholder': 'Masukkan nama lengkap Anda',
  'kontak.emailLabel': 'Email',
  'kontak.emailPlaceholder': 'email@perusahaan.com',
  'kontak.phoneLabel': 'Nomor Telepon',
  'kontak.phonePlaceholder': '+62 8xx-xxxx-xxxx',
  'kontak.company': 'Perusahaan / Institusi',
  'kontak.companyPlaceholder': 'Nama perusahaan Anda (opsional)',
  'kontak.projectType': 'Jenis Proyek',
  'kontak.projectTypePlaceholder': 'Pilih jenis proyek',
  'kontak.budget': 'Estimasi Anggaran',
  'kontak.budgetPlaceholder': 'Pilih kisaran anggaran',
  'kontak.message': 'Pesan / Deskripsi Proyek',
  'kontak.messagePlaceholder': 'Ceritakan kebutuhan proyek Anda secara singkat...',
  'kontak.submit': 'Kirim Pesan',
  'kontak.submitting': 'Mengirim...',
  'kontak.successTitle': 'Pesan Terkirim!',
  'kontak.successMsg': 'Terima kasih! Tim kami akan menghubungi Anda dalam 1x24 jam kerja.',
  'kontak.mapTitle': 'Lokasi Kami',
  'kontak.ctaTitle': 'Atau Hubungi Langsung via WhatsApp',
  'kontak.ctaSubtitle': 'Dapatkan respons lebih cepat melalui WhatsApp. Tim kami siap membantu Anda.',
  'kontak.ctaBtn': 'Chat via WhatsApp',
  'kontak.required': 'Wajib diisi',
  'kontak.charLimit': 'Maks 500 karakter',
  'kontak.sertifikasi': 'Sertifikasi & Legalitas',
  'kontak.socialMedia': 'Media Sosial',
  'kontak.kembali': 'Kembali',

  // === FOOTER (FIXED INDONESIA) ===
  'footer.perusahaan': 'PERUSAHAAN',
  'footer.layanan': 'LAYANAN',
  'footer.kontak': 'KONTAK',
  'footer.desc': 'Perusahaan Jasa Konstruksi/Kontraktor Umum anak perusahaan PT. Waringin Megah, berkomitmen melayani pelanggan dengan hasil pekerjaan berkualitas terbaik.',
  'footer.copyright': '© 2024 PT WARINGIN MEGA MANDIRI. HAK CIPTA DILINDUNGI.',
  'footer.privacy': 'Kebijakan Privasi',
  'footer.terms': 'Syarat & Ketentuan',

  // === PROJECT CARD & MODAL ===
  'project.lihatDetail': 'Lihat Detail',
  'project.lokasi': 'Lokasi',
  'project.tahun': 'Tahun',
  'project.klien': 'Klien',
  'project.nilai': 'Nilai',
  'project.kategori': 'Kategori',
  'project.status': 'Status',
  'project.diskusi': 'Diskusi Proyek Serupa',
  'project.tutup': 'Tutup',
  'project.statusSelesai': 'Selesai',
  'project.statusOngoing': 'Sedang Berjalan',
  'project.tahunLabel': 'Tahun',
  'project.tipeBangunan': 'Tipe Bangunan',
  'project.paketPekerjaan': 'Paket Pekerjaan',
  'project.lantai': 'Lantai',
  'project.luasBangunan': 'Luas Bangunan',
  'project.jumlahUnit': 'Jumlah Unit',
  'project.prevPhoto': 'Foto sebelumnya',
  'project.nextPhoto': 'Foto berikutnya',
  'featured.showcase': 'Proyek Berjalan',
  'featured.proyek': 'Proyek',
  'featured.unggulan': 'Sedang Berjalan',
  'featured.lihatSemua': 'Lihat Semua Proyek',
  'featured.detailProyek': 'Detail Proyek',
  'featured.selesai': 'Selesai',

  // === LAIN-LAIN / BADGES ===
  'badge.lpjk': 'Tersertifikasi LPJK',
  'badge.iso': 'ISO 9001:2015',
  'badge.sbu': 'Sertifikasi SBU',
  'sbu.41011': '41011 – Konstruksi Gedung Hunian',
  'sbu.41012': '41012 – Konstruksi Gedung Perkantoran',
  'sbu.41013': '41013 – Konstruksi Gedung Industri',
  'sbu.41014': '41014 – Konstruksi Gedung Perbelanjaan',
  'sbu.41015': '41015 – Konstruksi Gedung Kesehatan',
  'sbu.41017': '41017 – Konstruksi Gedung Penginapan',
  'sbu.41019': '41019 – Konstruksi Tempat Ibadah',
};

export default translations;